import { DashboardMenuOption } from 'components/dashboard-menu/constants'
import { DropdownWithDividersComponent } from 'components/dropdown/component'
import { HeaderComponent } from 'components/header/component'
import { EditButtonLight } from 'components/icons/lightedit'
import { Loading } from 'components/loading'
import { RasaContext } from 'context'
import * as GenericRedux from 'generic/genericRedux'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import * as React from 'react'
import { Row } from 'reactstrap'
import { Roles } from 'shared/constants'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { SourceTypes } from 'shared_server_client/constants'
import './_styles.scss'
import * as Types from './types'

const SourceTypeOptions = [
  { name: SourceTypes.facebook, value: SourceTypes.facebook },
  { name: SourceTypes.rss, value: SourceTypes.rss },
  { name: SourceTypes.twitter, value: SourceTypes.twitter },
]

class SourceDetailsComponent extends RasaReactComponent<Types.SourceDetailsProps, Types.SourceDetailsState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore
  private communityId: string

  constructor(p: any) {
    super(p, 'source')
    this.state = {
      category: '',
      editMode: false,
      id: null,
      url: '',
      isDirty: false,
      isEditing: false,
      isLoading: true,
      isSaving: false,
      name: '',
      type: '',
      sub_category: '',
    }
  }

  public componentDidMount() {
    this.sharedStore = SharedStore.instance(this.context)
    Promise.all([
      this.sharedStore.getValue(SharedKeys.role),
      this.sharedStore.getValue(SharedKeys.params),
      this.sharedStore.getValue(SharedKeys.activeCommunity),
    ]).then(([role, params, activeCommunity]) => {
      this.communityId = activeCommunity.communityId
      if (role === Roles.super_admin) {
        this.initializeRecord(params)
      } else {
        this.goBack()
      }
    })
  }

  public render = () => {
    const {category, identifier, name, options, sub_category, type} = this.props.data

    return (
      <div className="source-details">
        <div className="go-back" onClick={() => this.goBack()}>
          &lt; &nbsp; Go back
        </div>
        <HeaderComponent
          icon={'sources'}
          title={'Sources'}
          subTitle={this.state.id ? 'Edit Source' : 'Add Source'}
          description={[]}
        />
        {this.state.isLoading ? (
          <Loading size="64" />
        ) : (
          <Row className="info-table">
            <div className="edit-cancel-save">
              {this.state.isEditing ? (
                <p className="saving-button">Saving...</p>
              ) : this.state.editMode ? (
                <p className="edit-button-2">
                  <span
                    className="save"
                    onClick={() => {
                      this.setState({ isEditing: true }, () => {
                        if (
                          this.state.type.toLowerCase() !==
                          SourceTypes.facebook.toLowerCase()
                        ) {
                          this.propertyChanged('identifier', this.state.url)
                        } else {
                          this.propertyChanged(
                            'options',
                            JSON.stringify({ url: this.state.url }),
                          )
                        }
                        this.propertyChanged('category', this.state.category)
                        this.propertyChanged('name', this.state.name)
                        this.propertyChanged(
                          'sub_category',
                          this.state.sub_category,
                        )

                        this.saveRecord(this.props.data.id)
                          .then(() => {
                            this.setState({ isEditing: false, editMode: false })
                          })
                          .catch(() =>
                            this.setState({ isEditing: false, editMode: false }),
                          )
                      })
                    }}
                  >
                    Save
                  </span>
                  <span
                    className="cancel"
                    onClick={() => {
                      this.setState({ editMode: !this.state.editMode })
                    }}
                  >
                    Cancel
                  </span>
                </p>
              ) : (
                <p className="edit-button" onClick={this.initializeEdit}>
                  Edit
                  <EditButtonLight />
                </p>
              )}
            </div>
            <div className="properties-and-values">
              <div className="properties">
                <p
                  className={`property${
                    this.state.editMode ? ' edit-mode' : ''
                  }`}
                >
                  Name:
                </p>
                <p
                  className={`property${
                    this.state.editMode ? ' edit-mode' : ''
                  }`}
                >
                  Category (use '|' as separator):
                </p>
                <p
                  className={`property${
                    this.state.editMode ? ' edit-mode' : ''
                  }`}
                >
                  Sub Category (use '|' as separator):
                </p>
                <p
                  className={`property${
                    this.state.editMode ? ' edit-mode' : ''
                  }`}
                >
                  URL:
                </p>
                <p
                  className={`property${
                    this.state.editMode ? ' edit-mode' : ''
                  }`}
                >
                  Source Type:
                </p>
              </div>
              <div className="values">
                {this.state.editMode ? (
                  <div className="edit-details">
                    <p>
                      <input
                        type="text"
                        value={this.state.name}
                        onChange={(e) => {
                          e.preventDefault()
                          this.setState({ name: e.target.value })
                        }}
                      />
                    </p>
                    <p>
                      <input
                        type="text"
                        value={this.state.category}
                        onChange={(e) => {
                          e.preventDefault()
                          this.setState({ category: e.target.value })
                        }}
                      />
                    </p>
                    <p>
                      <input
                        type="text"
                        value={this.state.sub_category}
                        onChange={(e) => {
                          e.preventDefault()
                          this.setState({ sub_category: e.target.value })
                        }}
                      />
                    </p>
                    <p>
                      <input
                        type="text"
                        value={this.state.url}
                        onChange={(e) => {
                          e.preventDefault()
                          this.setState({ url: e.target.value })
                        }}
                      />
                    </p>
                    <div>
                      <DropdownWithDividersComponent
                        data={SourceTypeOptions}
                        selected={this.props.data.type}
                        onChange={(e) => this.onDropdownChange(e)}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="details-view">
                    <p>{name || '-'}</p>
                    <p>{category || '-'}</p>
                    <p>{sub_category || '-'}</p>
                    <p>
                      {type
                        ? type.toLowerCase() !==
                          SourceTypes.facebook.toLocaleLowerCase()
                          ? identifier || '-'
                          : options && JSON.parse(options).url
                          ? JSON.parse(options).url
                          : '-'
                        : '-'}
                    </p>
                    <p>{type || '-'}</p>
                  </div>
                )}
              </div>
            </div>
          </Row>
        )}
      </div>
    )
  }

  private goBack = () => this.props.push(DashboardMenuOption.adminContentLibrary)

  private initializeRecord(params: any) {
    if (params.id) {
      this.setState({id: params.id})
      this.loadRecord(this.communityId, params.id).then(() => this.setState({isLoading: false}))
    } else {
      this.loadRecord(this.communityId, null).then(() => {
        this.props.propertiesChanged({
          category: '',
          id: null,
          identifier: '',
          name: '',
          options: '',
          type: '',
          sub_category: '',
        })
        this.setState({editMode: true, isLoading: false})
      })
    }
  }

  private initializeEdit = () => {
    if (this.state.editMode) {
      this.setState({
        category: '',
        editMode: false,
        name: '',
        sub_category: '',
        type: '',
        url: '',
      })
    } else {
      const {category, identifier, name, options, sub_category, type} = this.props.data
      const url = type.toLowerCase() !== SourceTypes.facebook.toLowerCase()
      ? identifier
      : options ? JSON.parse(options).url : ''
      this.setState({
        category,
        editMode: true,
        url,
        name,
        type,
        sub_category,
      })
    }
  }

  private onDropdownChange = (e) => {
      e.preventDefault()
      this.setState({type: e.target.value})
      this.propertiesChanged({type: e.target.value})
  }

}

//tslint:disable-next-line
export const ContentPoolSourceDetails = GenericRedux.registerNewNestedComponent(
  SourceDetailsComponent, 'source_details')
